module.exports = __webpack_public_path__ + "static/media/Untitled.a831bebc.png";